<template>
  <a-modal
    :width="1000"
    :visible="visible"
    @cancel="handleCancel"
    :title="'账单明细'"
    :maskClosable="false"
    :footer="false"
  >
    <bill></bill>
  </a-modal>
</template>

<script>
import Bill from './bill'
export default {
    components: {
      Bill
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 7 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 13 }
        },
        mdl: {},
        visible: false
      }
    },
    computed: {},
    created () {},
    methods: {
        show () {
            this.visible = true
        },
        handleCancel () {
            this.visible = false
        },
        handleSeccess () {
          this.visible = false
          this.$emit('ok')
        }
    }
}
</script>
<style lang="less">
</style>
